import { Component, OnInit,Input } from '@angular/core';
import { statusCodes, AuthenticationService } from 'ew-common-lib';
import { EwMaTableListService } from '../../ew-ma-table-list.service';
import { TranslateService } from '@ngx-translate/core';
import { EwTranslateService } from '../../services/ew-translate.service';
import {Sort} from '@angular/material/sort';
import { isNumber } from 'highcharts';
import * as moment from 'moment';

@Component({
  selector: 'lib-ew-ma-attendee-list',
  templateUrl: './attendee-list.component.html',
  styleUrls: ['./attendee-list.component.css']
})
export class AttendeeListComponent implements OnInit {

  /**
   * @description
   * Language
   */
  @Input() default_lang: string = 'en';

  @Input() userId:number = 7939;

  public data = [];
  public sessionDetaildata = [];
  public webinars= [];
  public filterWebinars= [];
  public offers= [];
  public filterOffers= [];
  public polls= [];
  public filterPolls= [];
  public timezones= [];
  public filterTimezones= [];
  public page: number = 1;
  public offset: number = 0;
  public limit: number = 10;
  public limitStr = "10";
  public totalItems: number = 0;
  public search:string = '';

  public webinarSearchInsideDropDown = "";
  public webinarTimezoneSearchInsideDropDown = "";
  public offerSearchInsideDropDown = "";
  public pollSearchInsideDropDown = "";

  public attendee_count:number = 0;
  public registrants_count:number = 0;

  public showSectionLoader: boolean = true;

  public showlistLoader: boolean = true;

  public openSidebar: boolean = false;

  public openAttendeeDetailSidebar: boolean = false;

  public activeFilterTypeOption: string ="filter_details";

  public attendee_index: number =null;

  public selected:string="option1";

  //public filterObj:any=[];

  public filterObj:object={};

  public countQuery:object={};
  public countRegistrantsQuery:object={};


  public selected_event_type:string="all";
  public selected_event:string="";
  public selected_attended:string="all";
  public selected_register_source:string="";
  public searched_location:string="";
  public selected_browser_condition:string="";
  public selected_browser_name:string="";
  public selected_device_condition:string="";
  public selected_device:string="all";
  public searched_UTM:string="";
  public searched_timezone:string="";
  public selected_watched_reply_condition:string="yes";
  public searched_attendee_detail:string="";
  public percent_watched_reply:number;
  public percent_attendance:number;
  public selected_attendance_type:string="event_room";
  public selected_attendance_condition:string="equal";
  public selected_cta_type:string="offers";
  public selected_offer_tags:string="Saw_the_offer_but_did_not_click";
  public selected_offer:string="all";
  public selected_poll_tags:string="answered_poll";
  public selected_poll:string="all";
  public selected_event_schedule_type:string="";
  public selected_event_timezone:string="";

  public bgRandom = [];

  public bg = [
    'seablue', 'lighten-prple', 'greylight', 'lighten-red','purple-blue-light','tan-red','pink-light'
  ];


  public baseECQuery:object;

  public model:object = {};

  constructor(
    private tableListService: EwMaTableListService,
    private ewTranslateService: EwTranslateService,
    public translate: TranslateService,
    private authenticationService: AuthenticationService
  ) {

    if(this.authenticationService.getLoginUserId()){
      this.userId = this.authenticationService.getLoginUserId();
    }

  }

  ngOnInit(): void {
    

    this.baseECQuery = {
      "user_id" : this.userId,
      "query" : {
        "index" : "attendees",
        "body": {
          "from" :this.offset,
          "size": this.limit,
          "query" : {
            "bool" :{
              "must" : [
                {
                  "term" : {
                    "owner_id" :this.userId
                  }
                },
              ],
              "must_not" : [
              ],

            }
          },
          "sort" : {
            "signup" :{
              "order" : "desc"
            }
          }
        }
      }
    };
    /**
     * @description::if page limit is changed when filter is applied then need to fetch results based on filter applied.
     */
    if (!this.isFilterApplied) { 
      this.model=JSON.parse(JSON.stringify(this.baseECQuery));
    }
    this.getList();
    //this.fetchRegistrantCount();
    //this.fetchAttendeeCount();
    this.fetchTotalCount();
    this.getESWebinars();
    this.getESoffers();
    this.getESPoll();
    this.getESTimezone();


    this.translate.setDefaultLang(this.default_lang);
    this.translate.use(this.default_lang).subscribe(() => {
      this.ewTranslateService.init();
    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  /**
   *
   */
   public handleMaxNumber(filterName) {
    if(filterName == "percent_attendance" && Number(this.percent_attendance) > 100){
      this.percent_attendance = 100;
    }

    if(filterName == "percent_watched_reply" && Number(this.percent_watched_reply) > 100){
      this.percent_watched_reply = 100;
    }
  }


  getShortName(fullName) {
    let shortName=fullName.split(' ').map(n => n[0]).join('');
    return shortName.toUpperCase();
  }

  eventType(type) {
    let returnValue="Automated";
    if(type == "2"){
      returnValue="Automated Gold";
    }else if(type == "1"){
      returnValue="Live";
    }
    return returnValue;
  }


  /**
   * Convert Seconds into mins
   * @param d digit
   * @returns
   */
  secondsToHms(d:number) {
      //d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);

      //var hDisplay = h > 0 ? h + (h == 1 ? " H, " : ":") : "";
      var hDisplay = h ;
      var mDisplay = m > 0 ? m + (m == 1 ? " M, " : "") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " S" : " seconds") : "";
      //return hDisplay + mDisplay + sDisplay;
      return h+"H:"+m+"M";
  }


  /**
   * Filter dropdown options
   */
  public onChangeFilterWebinars() {
    this.filterWebinars=this.webinars.filter(item => item._source.webinar_name.toLowerCase().includes(this.webinarSearchInsideDropDown.toLowerCase()));

  }



  /**
   * Filter dropdown options
   */
  public onChangeFilterOffers() {
    this.filterOffers=this.offers.filter(item => item._source.offer_name.toLowerCase().indexOf(this.offerSearchInsideDropDown.toLowerCase()) > -1);
  }

  /**
   * Filter dropdown options
   */
  public onChangeFilterPolls() {
    this.filterPolls=this.polls.filter(item => item._source.poll_title.toLowerCase().indexOf(this.pollSearchInsideDropDown.toLowerCase()) > -1);
  }

  /**
   * Filter dropdown options
   */
  public onChangeFilterWebinarsTimezone() {
    this.filterTimezones=this.timezones.filter(item => item.key.toLowerCase().indexOf(this.webinarTimezoneSearchInsideDropDown) > -1);
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
    
  }

  searchKeyInQuery(ESKeyword:string,backendKey:string,staticFieldValue:any="") {
    let insertIndex=null;

    if(staticFieldValue == "-1"){

      this.model["query"]["body"]["query"]["bool"]["must_not"].forEach((element, index) => {

        let elementKeysArray=Object.keys(element);
        //offer or polls index
        if(elementKeysArray[0] == "query_string" && element[ESKeyword] !== undefined ){
          insertIndex=index;
        }

      });
    }


    if(staticFieldValue != "-1"){

      this.model["query"]["body"]["query"]["bool"]["must"].forEach((element, index) => {

        let elementKeysArray=Object.keys(element);
        //console.log("object keys===",elementKeysArray,element);
        //offer or polls index
        if(elementKeysArray[0] == "query_string" && element[ESKeyword] !== undefined ){
          insertIndex=index;
        }
        //Multi value search, Full text
        if(elementKeysArray[0] == "multi_match"){
          // match the field array then get the index to replace with new values
          if(element[ESKeyword] !== undefined && JSON.stringify(element[ESKeyword][backendKey])==JSON.stringify(staticFieldValue)) {
            insertIndex=index;
          }
        }

        //Single value search
        if((elementKeysArray[0] == "match" || elementKeysArray[0] == "term" ||  elementKeysArray[0] == "range") && element[ESKeyword] !== undefined){
          let elementECKeywordArray=Object.keys(element[ESKeyword]);

          let internalArrayIndex=elementECKeywordArray.indexOf(backendKey);

          if (internalArrayIndex !== -1) {
            insertIndex=index;
          }
        }

      });
    }


    return insertIndex;

  }

  public isFilterApplied: boolean = false;
  applyFilter(type:string) { 

    this.isFilterApplied = true;
    let ESKeyword="term";
    //console.log('app filter', type);
    this.page = 1;
    this.model["query"]["body"]["from"]=0;
    //this.pageChanged(1);
    switch (type) {
      case "webinars":
        let fetchList = 0;


        let webinarTypeInInteger="-1";
        if(this.selected_event_type =="live"){
          webinarTypeInInteger="1";
          this.filterObj["event_type"]=this.selected_event_type;
        }else if(this.selected_event_type =="evergreen"){
          webinarTypeInInteger="2";
          this.filterObj["event_type"]="Automated Gold";
        }else if(this.selected_event_type =="simulated"){
          webinarTypeInInteger="0";
          this.filterObj["event_type"]="Automated";
        }
        if(webinarTypeInInteger!=="-1"){
        const filterQuery={
          "term" : {
            "webinar_type" : webinarTypeInInteger
          }
        };
        let insertIndex=null;
        insertIndex=this.searchKeyInQuery(ESKeyword,"webinar_type");

        if (insertIndex !== null) {
          this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
        }else{
          this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
        }
        fetchList = 1;
      }else{
          this.clearFilterFromQuery("term","webinar_type");
          fetchList = 1;
      }





        if(this.selected_event_type =="evergreen"){

          if(this.selected_event_schedule_type){
            let schedule_type = "All";
            switch(this.selected_event_schedule_type){
              case "1":
                schedule_type = "Scheduled";
                break;
              case "2":
                schedule_type = "Instant Replay";
                break;
              case "3":
                schedule_type = "Just In Time";
                break;
            }
            this.filterObj["event_schedule_type"]= schedule_type;//this.selected_event_schedule_type;
            if(Number(this.selected_event_schedule_type)>0){
                const filterQuery={
                  "match": {
                    "schedule_type": this.selected_event_schedule_type
                  }
                }

                let insertIndex=null;
                insertIndex=this.searchKeyInQuery("match","schedule_type");

                if (insertIndex !== null) {
                  this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
                }else{
                  this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
                }
                fetchList = 1;
            }else{
              this.clearFilterFromQuery("match","schedule_type");
              fetchList = 1;
            }
          }

          if(this.selected_event_timezone){

            let insertIndex=null;
            insertIndex=this.searchKeyInQuery("match","timezone");

            // If filter already applied then remove the first one, in case of all filter.
            if(this.selected_event_timezone == "0"){
              this.clearFilterFromQuery("match","timezone");
              fetchList = 1;
            }


            this.filterObj["event_timezone"]=(this.selected_event_timezone == "0") ? "All":this.selected_event_timezone;

            if(this.selected_event_timezone !== "0"){
              const filterQuery={
                "match": {
                  "timezone": this.selected_event_timezone
                }
              }



              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
              fetchList = 1;
            }


          }

         // if(this.selected_event == "" && ((this.selected_event_schedule_type) || (this.selected_event_timezone))){
           // this.getList();
         // }


        }

        if(this.selected_event){
         // this.filterObj["event"]=this.webinars[this.selected_event]._source.webinar_name;
          this.filterObj["event"]= this.getValueFromStore(this.webinars, '_id',this.selected_event, 'webinar_name');
          let selected_webinar_id=this.selected_event;
         // let selected_webinar_id=this.webinars[this.selected_event]._source.webinar_id;

          const filterQuery={
            "term" : {
              "webinar_id" : selected_webinar_id
            }
          };

          let insertIndex=null;
          insertIndex=this.searchKeyInQuery(ESKeyword,"webinar_id");

          if (insertIndex !== null) {
            this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
          }else{
            this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
          }
         // this.getList();
         fetchList = 1;
        }else{
          this.filterObj['event'] = this.translate.store.translations[this.default_lang].ATTENDEE_LIST.ALL_EVENTS;
          this.clearFilterFromQuery("term","webinar_id");
          fetchList = 1;
        }

        //if(this.selected_event == ""  && (this.selected_event_schedule_type == "") && (this.selected_event_timezone == "")){
          //this.getList();
       // }
        if(fetchList==1){
          //console.log('get list called');
          this.getList();
        }
        break;

      case "cta":
        //this.filterObj["CTA_type"]=this.selected_cta_type;

        if(this.selected_cta_type =="offers"){

          let selected_offer_id="";
          let filterOfferSectionQuery="offer_action_*";
          let filterOfferTagsQuery="1";

          if(this.selected_offer == "all"){
            this.filterObj[this.selected_cta_type]=this.translate.store.translations[this.default_lang].ALL_OFFERS+" | "+this.selected_offer_tags;
          }else{
            this.filterObj[this.selected_cta_type]= this.getValueFromStore(this.offers, '_id',this.selected_offer, 'offer_name')+" | "+this.selected_offer_tags;
            // this.offers[this.selected_offer]._source.offer_name+" "+this.selected_offer_tags;

            selected_offer_id= this.selected_offer ;//this.offers[this.selected_offer]._source.offer_id;
            filterOfferSectionQuery="offer_action_"+selected_offer_id+"_*";
          }

          if(this.selected_offer_tags =="clicked_the_offer"){
            filterOfferTagsQuery="2"
          }

          if(this.selected_offer_tags =="did_not_see_the_offer"){
            filterOfferTagsQuery="-1"
          }



          if(filterOfferTagsQuery == "-1"){

            // Clear Filter For other selection If applied
            this.clearFilterFromQuery("query_string","query","1");
            this.clearFilterFromQuery("query_string","query","2");

            const filterQuery={
                "query_string": {
                "fields": [
                  filterOfferSectionQuery
                ],
                "query": "1"
                }
            };
            const filterQuery1={
                "query_string": {
                "fields": [
                  filterOfferSectionQuery
                ],
                "query": "2"
                }
              };
            const filterQuery2={
                "query_string": {
                "fields": [
                  filterOfferSectionQuery
                ],
                "query": "3"
                }
            };

            //let insertIndex=null;
            //insertIndex=this.searchKeyInQuery("query_string",filterOfferTagsQuery);

            //if (insertIndex !== null) {
              //this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
            //}else{
              this.model["query"]["body"]["query"]["bool"]["must_not"].push(filterQuery);
              this.model["query"]["body"]["query"]["bool"]["must_not"].push(filterQuery1);
              this.model["query"]["body"]["query"]["bool"]["must_not"].push(filterQuery2);
            //}



          }else{
            // Clear Filter for Did not see the poll
            this.clearFilterFromQuery("query_string","query","-1");

            const filterQuery={
              "query_string": {
                "fields": [
                  filterOfferSectionQuery
                ],
                "query": filterOfferTagsQuery
              }
            };

            let insertIndex=null;
            insertIndex=this.searchKeyInQuery("query_string",filterOfferTagsQuery);

            if (insertIndex !== null) {
              this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
            }else{
              this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
            }
          }

          this.getList();
        }

        if(this.selected_cta_type =="polls"){

          let selected_poll_id="";
          let filterPollSectionQuery="poll_action_*";
          let filterPollTagsQuery="1";

          if(this.selected_poll == "all"){
            this.filterObj[this.selected_cta_type]=this.translate.store.translations[this.default_lang].ALL_POLLS+" | "+this.selected_poll_tags;
          }else{
            this.filterObj[this.selected_cta_type]=  this.getValueFromStore(this.polls, '_id',this.selected_poll, 'poll_title')+" | "+this.selected_poll_tags;
            //this.polls[this.selected_poll]._source.poll_title+" "+this.selected_poll_tags;

            selected_poll_id= this.selected_poll;//this.polls[this.selected_poll]._source.poll_id;
            filterPollSectionQuery="poll_action_"+selected_poll_id+"_*";
          }

          if(this.selected_poll_tags =="answered_poll"){
            filterPollTagsQuery="2"
          }

          if(this.selected_poll_tags =="did_not_see_the_poll"){
            filterPollTagsQuery="-1"
          }



          if(filterPollTagsQuery == "-1"){

            // Clear Filter For other selection If applied
            this.clearFilterFromQuery("query_string","query","1");
            this.clearFilterFromQuery("query_string","query","2");

            const filterQuery={
                "query_string": {
                "fields": [
                  filterPollSectionQuery
                ],
                "query": "1"
                }
            };
            const filterQuery1={
                "query_string": {
                "fields": [
                  filterPollSectionQuery
                ],
                "query": "2"
                }
              };

            this.model["query"]["body"]["query"]["bool"]["must_not"].push(filterQuery);
            this.model["query"]["body"]["query"]["bool"]["must_not"].push(filterQuery1);


            // let insertIndex=null;
            // insertIndex=this.searchKeyInQuery(ESKeyword,"webinar_id");

            // if (insertIndex !== null) {
            //   this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
            // }else{
            //   this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
            // }
            this.getList();


          }else{
            // Clear Filter for Did not see the poll
            this.clearFilterFromQuery("query_string","query","-1");

            const filterQuery={
              "query_string": {
                "fields": [
                  filterPollSectionQuery
                ],
                "query": filterPollTagsQuery
              }
            };

            let insertIndex=null;
            insertIndex=this.searchKeyInQuery("query_string",filterPollSectionQuery);

            if (insertIndex !== null) {
              this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
            }else{
              this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
            }

            // let insertIndex=null;
            // insertIndex=this.searchKeyInQuery(ESKeyword,"webinar_id");

            // if (insertIndex !== null) {
            //   this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
            // }else{
            //   this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
            // }
            this.getList();
          }
        }
        break;

      case "attendee_detail_filter":
        if(!this.searched_attendee_detail){
          return false
        }
        this.filterObj["user_details"]=this.searched_attendee_detail;

        if(this.searched_attendee_detail){
          const filterQuery={
            "bool":{
              "should":[
                  {
                  "multi_match" : {
                    "query":      this.searched_attendee_detail,
                    "fields":     ["fields_text_*", "fields_value_*", "attendee_name", "attendee_email", "phone"],
                  }
                }
                ,{
                  "query_string" : {
                    "query" :  "*"+this.searched_attendee_detail+"*",
                    "fields" : ["fields_text_*", "fields_value_*", "attendee_name", "attendee_email", "phone"],
                    "allow_leading_wildcard": true,
                    
                }
                }                     
              ]                  
          }
        }


let t = this.model["query"]["body"]["query"]["bool"]["must"];
t.forEach((element, index) => {
  let boolQuery = element['bool'];
  if(boolQuery){
  //  boolQuery['should'] = '';
    delete boolQuery['should'];
  }
});
this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
/*const filterQuery={
  "multi_match": {
    "query": this.searched_attendee_detail,
    "fields" :["fields_text_*", "fields_value_*", "attendee_name", "attendee_email", "phone"],
    }
}
let insertIndex=null;
insertIndex=this.searchKeyInQuery("bool","fields",["fields_text_*", "fields_value_*", "attendee_name", "attendee_email", "phone"],);
if (insertIndex !== null) {
  this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
}else{
  this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
}*/

          this.getList();
        }
        break;

      case "attended":
        this.filterObj["attended"]=this.selected_attended;

        if(this.selected_attended){
          if(this.selected_attended=='all'){
            this.clearFilterFromQuery("term","event_activity");
          }else{
            const filterQuery={
              "term" : {
                "event_activity" : (this.selected_attended == "yes") ? 1 : 0
              }
            };

            let insertIndex=null;
            insertIndex=this.searchKeyInQuery(ESKeyword,"event_activity");

            if (insertIndex !== null) {
              this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
            }else{
              this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
            }
          }

          this.getList();
        }
        break;

      case "attendance":

        if((this.percent_attendance) && (this.selected_attendance_type)){

          this.filterObj["attendance_rate"]=this.selected_attendance_type+" | "+this.selected_attendance_condition+" | "+this.percent_attendance+"%";

          if(this.selected_attendance_type == "event"){
            const filterQuery={
              "term" : {
                "event_activity" : 1
              }
            };
            let insertIndex=null;
            insertIndex=this.searchKeyInQuery(ESKeyword,"event_activity");

            if (insertIndex !== null) {
              this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
            }else{
              this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
            }

            if(this.selected_attendance_condition == "equal"){
              const filterQuery={
                "term" : {
                  "event_watched_percentage" : this.percent_attendance
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery(ESKeyword,"event_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
            }

            if(this.selected_attendance_condition == "greater_than"){
              const filterQuery={
                "range" : {
                  "event_watched_percentage" : {
                    "gt" : this.percent_attendance,
                    "lte" : 100
                  }
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery("range","event_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
            }

            if(this.selected_attendance_condition == "greater_than_or_equal_to"){
              const filterQuery={
                "range" : {
                  "event_watched_percentage" : {
                    "gte" : this.percent_attendance,
                    "lte" : 100
                  }
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery("range","event_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
            }

            if(this.selected_attendance_condition == "less_than"){
              const filterQuery={
                "range" : {
                  "event_watched_percentage" : {
                    "gte" : 0,
                    "lt" : this.percent_attendance
                  }
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery("range","event_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
            }

            if(this.selected_attendance_condition == "less_than_or_equal_to"){
              const filterQuery={
                "range" : {
                  "event_watched_percentage" : {
                    "gte" : 0,
                    "lte" : this.percent_attendance
                  }
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery("range","event_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
            }
          }

          if(this.selected_attendance_type == "replay"){
            const filterQuery={
              "term" : {
                "replay_activity" : 1
              }
            };



            let insertIndex=null;
            insertIndex=this.searchKeyInQuery(ESKeyword,"replay_activity");

            if (insertIndex !== null) {
              this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
            }else{
              this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
            }
            if(this.selected_attendance_condition == "equal"){
              const filterQuery={
                "term" : {
                  "replay_watched_percentage" : this.percent_attendance
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery(ESKeyword,"replay_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
            }

            if(this.selected_attendance_condition == "greater_than"){
              const filterQuery={
                "range" : {
                  "replay_watched_percentage" : {
                    "gt" : this.percent_attendance,
                    "lte" : 100
                  }
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery("range","replay_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
            }

            if(this.selected_attendance_condition == "greater_than_or_equal_to"){
              const filterQuery={
                "range" : {
                  "replay_watched_percentage" : {
                    "gte" : this.percent_attendance,
                    "lte" : 100
                  }
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery("range","replay_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
            }

            if(this.selected_attendance_condition == "less_than"){
              const filterQuery={
                "range" : {
                  "replay_watched_percentage" : {
                    "gte" : 0,
                    "lt" : this.percent_attendance
                  }
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery("range","replay_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
            }

            if(this.selected_attendance_condition == "less_than_or_equal_to"){
              const filterQuery={
                "range" : {
                  "replay_watched_percentage" : {
                    "gte" : 0,
                    "lte" : this.percent_attendance
                  }
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery("range","replay_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
              }
            }

          }

          this.getList();
        }
        break;

      case "location":
        if(!this.searched_location){
          return false
        }
        this.filterObj["location"]=this.searched_location;
        if(this.searched_location){
          const filterQuery={
            "multi_match": {
              "query": this.searched_location,
              "type":  "best_fields",
                "fields": [
                  "location_registration_country_code", "location_registration_country", "location_registration_state", "location_registration_state", "location_registration_city",
                 // "location_event_country_code", "location_event_country", "location_event_state", "location_event_state", "location_event_city",
                 // "location_replay_country_code", "location_replay_country", "location_replay_state", "location_replay_state", "location_replay_city"
                ],
                "operator":   "and"
              }
          }

          let insertIndex=null;
          insertIndex=this.searchKeyInQuery("multi_match","fields",["location_registration_country_code", "location_registration_country", "location_registration_state", "location_registration_state", "location_registration_city",
         // "location_event_country_code", "location_event_country", "location_event_state", "location_event_state", "location_event_city","location_replay_country_code", "location_replay_country", "location_replay_state", "location_replay_state", "location_replay_city"
        ]);

          if (insertIndex !== null) {
            this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
          }else{
            this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
          }
          this.getList();
        }
        break;

      case "browser":
        if(!this.selected_browser_name){
          return false
        } 
        this.filterObj["browser"]=this.selected_browser_name;

        if(this.selected_browser_name){
          const filterQuery={
            "multi_match": {
              "query": this.selected_browser_name,
              "fields": [ "browser_registration_browser_name", "browser_event_browser_name", "browser_replay_browser_name"]
              }
          }

          let insertIndex=null;
          insertIndex=this.searchKeyInQuery("multi_match","fields",[ "browser_registration_browser_name", "browser_event_browser_name", "browser_replay_browser_name"]);

          if (insertIndex !== null) {
            this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
          }else{
            this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
          }

          this.getList();
        }
        break;

      case "device":
        this.filterObj["device"]=this.selected_device;

        if(this.selected_device!='all'){
          const filterQuery={
            "multi_match": {
              "query": this.selected_device,
                "fields": [ "device_registration_device_type", "device_event_device_type", "device_replay_device_type"]
              }
          }

          let insertIndex=null;
          insertIndex=this.searchKeyInQuery("multi_match","fields",["device_registration_device_type", "device_event_device_type", "device_replay_device_type"]);

          if (insertIndex !== null) {
            this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
          }else{
            this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
          }

          this.getList();
        }else{
          this.clearFilterFromQuery("multi_match","fields", JSON.stringify(["device_registration_device_type", "device_event_device_type", "device_replay_device_type"]));
          this.getList();
        }
        break;

      case "UTM_params":
        if(!this.searched_UTM){
          return false
        }
        this.filterObj["UTM_params"]=this.searched_UTM;

        if(this.searched_UTM){
          const filterQuery={
            "multi_match": {
              "query": this.searched_UTM,
                "fields": [ "utm_source", "utm_medium", "utm_campaign", "utm_content"]
              }
          }

          let insertIndex=null;
          insertIndex=this.searchKeyInQuery("multi_match","fields",["utm_source", "utm_medium", "utm_campaign", "utm_content"]);

          if (insertIndex !== null) {
            this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
          }else{
            this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
          }

          this.getList();
        }
        break;

      case "timezone":
        this.filterObj["timezone"]=this.searched_timezone;

        if(this.searched_timezone){
          const filterQuery={
            "match": {
              "timezone": this.searched_timezone
            }
          }

          let insertIndex=null;
          insertIndex=this.searchKeyInQuery("match","timezone");

          if (insertIndex !== null) {
            this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
          }else{
            this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
          }
          this.getList();
        }
        break;

      case "watched_replay":
        let applyFilter = 0;
        if ((this.selected_watched_reply_condition == "yes")) {
          if (!this.percent_watched_reply) this.percent_watched_reply = 0;
          this.filterObj["watched_replay"] = `${this.selected_watched_reply_condition} ${this.percent_watched_reply == 0 ? '' : `| ${this.percent_watched_reply}%`}`;
          applyFilter = 1;
        }else if(this.selected_watched_reply_condition == "no"){
          this.filterObj["watched_replay"]=this.selected_watched_reply_condition;
          applyFilter = 1;
        }
        if(applyFilter==1){
          //Clear the Percent Filter If it applied last time.
          if(this.selected_watched_reply_condition == "no"){
            //console.log("inside no case");
            this.clearFilterFromQuery("term","replay_watched_percentage");
          }


          if(this.selected_watched_reply_condition){
            const filterQuery={
              "term" : {
                "replay_activity" : (this.selected_watched_reply_condition == "yes") ? 1 : 0
              }
            };

            let insertIndex=null;
            insertIndex=this.searchKeyInQuery("term","replay_activity");

            if (insertIndex !== null) {
              this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
            }else{
              this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
            }

            if(this.percent_watched_reply >= 0 && this.selected_watched_reply_condition == "yes"){
              const filterRangeQuery={
                "term" : {
                  "replay_watched_percentage" :this.percent_watched_reply
                }
              };

              let insertIndex=null;
              insertIndex=this.searchKeyInQuery("term","replay_watched_percentage");

              if (insertIndex !== null) {
                this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterRangeQuery;
              }else{
                this.model["query"]["body"]["query"]["bool"]["must"].push(filterRangeQuery);
              };
            }

            this.getList();
            this.percent_watched_reply == 0 ? this.percent_watched_reply = null : this.percent_watched_reply;
          }


        }
        break;

      case "register_source":

        switch(this.selected_register_source){
          case "0":
            this.filterObj["registration_source"]= this.translate.store.translations[this.default_lang].REG_SOURCE_OPTIONS.REG_PAGE;
            break;
          case "1":
            this.filterObj["registration_source"]=this.translate.store.translations[this.default_lang].REG_SOURCE_OPTIONS.ZAPIER;
            break;
          case "2":
            this.filterObj["registration_source"]=this.translate.store.translations[this.default_lang].REG_SOURCE_OPTIONS.WIDGET;
            break;
          case "3":
            this.filterObj["registration_source"]=this.translate.store.translations[this.default_lang].REG_SOURCE_OPTIONS.ONE_CLICK_REG;
            break;
          case "4":
            this.filterObj["registration_source"]=this.translate.store.translations[this.default_lang].REG_SOURCE_OPTIONS.ATTENDEE_JOIN_LINK;
            break;
        }

        if(this.selected_register_source !==""){
          const filterQuery={
            "term" : {
              "reg_source" : this.selected_register_source
            }
          };

          let insertIndex=null;
          insertIndex=this.searchKeyInQuery(ESKeyword,"reg_source");

          if (insertIndex !== null) {
            this.model["query"]["body"]["query"]["bool"]["must"][insertIndex]=filterQuery;
          }else{
            this.model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
          }

          this.getList();
        }else{
          this.filterObj['registration_source'] = this.translate.store.translations[this.default_lang].REG_SOURCE_OPTIONS.ALL;
          this.clearFilterFromQuery("term","reg_source");
          this.getList();
        }

        break;
      default:
          //console.log("No such key exists!");
          break;
    }
  }

  /**
   *
   * @param key Fontend Key used for filter
   */

  clearFilter(key:string) {
    console.log('filter clear', key);
    //this.filterObj[key]="";
    delete this.filterObj[key];

    if(key == "event_type"){
      this.clearFilterFromQuery("term","webinar_type");
      this.getList();
    }

    if(key == "event_schedule_type"){
      this.clearFilterFromQuery("match","schedule_type");
      this.getList();
    }

    if(key == "event"){
      this.clearFilterFromQuery("term","webinar_id");
      this.getList();
    }

    if(key == "event_timezone"){
      this.clearFilterFromQuery("match","timezone");
      this.getList();
    }


    if(key == "offers"){
      let filterOfferTagsQuery="1";

      if(this.selected_offer_tags =="clicked_the_offer"){
        filterOfferTagsQuery="2"
      }

      if(this.selected_offer_tags =="did_not_see_the_offer"){
        filterOfferTagsQuery="-1"
      }

      this.clearFilterFromQuery("query_string","query",filterOfferTagsQuery);
      this.getList();
    }

    if(key == "polls"){
      let filterPollTagsQuery="1";
      if(this.selected_poll_tags =="answered_poll"){
        filterPollTagsQuery="2"
      }

      if(this.selected_poll_tags =="did_not_see_the_poll"){
        filterPollTagsQuery="-1"
      }

      this.clearFilterFromQuery("query_string","query",filterPollTagsQuery);
      this.getList();
    }


    if(key == "attended"){
      this.clearFilterFromQuery("term","event_activity");
      this.getList();
    }

    if(key == "user_details"){
      console.log('user details', this.searched_attendee_detail);
      this.clearFilterFromQuery("multi_match","query",this.searched_attendee_detail);
      this.clearFilterFromQuery("query_string","query",'*'+this.searched_attendee_detail+'*');
      this.getList();
    }


    if(key == "watched_replay"){
      this.clearFilterFromQuery("term","replay_activity");
      this.clearFilterFromQuery("term","replay_watched_percentage");
      this.getList();
    }

    if(key == "attendance_rate"){
      this.clearFilterFromQuery("term","event_activity");
      this.clearFilterFromQuery("term","event_watched_percentage");
      this.clearFilterFromQuery("range","event_watched_percentage");

      this.clearFilterFromQuery("term","replay_activity");
      this.clearFilterFromQuery("term","replay_watched_percentage");
      this.clearFilterFromQuery("range","replay_watched_percentage");
      this.getList();
    }




    if(key == "register_source" || key == "registration_source"){
      this.clearFilterFromQuery("term","reg_source");
      this.getList();
    }

    if(key == "timezone"){
      this.clearFilterFromQuery("match","timezone");
      this.getList();
    }

    if(key == "location"){
      this.clearFilterFromQuery("multi_match","query",this.searched_location);
      this.getList();
    }

    if(key == "browser"){
      this.clearFilterFromQuery("multi_match","query",this.selected_browser_name);
      this.getList();
    }

    if(key == "device"){
      this.clearFilterFromQuery("multi_match","query",this.selected_device);
      this.getList();
    }

    if(key == "UTM_params"){
      this.clearFilterFromQuery("multi_match","query",this.searched_UTM);
      this.getList();
    }

  }

  /**
 *
 * @param ESKeyword Backend keyword of ES
 * @param key Backend keyword for column
 */

  clearFilterFromQuery(ESKeyword:string,key:any,frontendValue:string="") {

    if(frontendValue == "-1"){
      this.model["query"]["body"]["query"]["bool"]["must_not"]=[];
      // this.model["query"]["body"]["query"]["bool"]["must_not"].forEach((element, index) => {

      //   let elementKeysArray=Object.keys(element);
      //   console.log("elementKeysArray");
      //   console.log(elementKeysArray);

      //   //Offers and Polls Tagging filters
      //   if(elementKeysArray[0] == "query_string"){
      //     console.log("inside");

      //     console.log(element[ESKeyword][key]);
      //     console.log(frontendValue);

      //     if(element[ESKeyword][key] == frontendValue) {

      //       console.log("main condition");

      //       this.model["query"]["body"]["query"]["bool"]["must"].splice(index,1);
      //     }
      //   }
      // });
    }

    if(frontendValue != "-1"){
      this.clearFilterRec(this.model["query"]["body"]["query"]["bool"]["must"], ESKeyword, key, frontendValue, this.model);
      /*
      this.model["query"]["body"]["query"]["bool"]["must"].forEach((element, index) => {

        let elementKeysArray=Object.keys(element);
        if(elementKeysArray[0] == "bool"){


        }

        //Offers and Polls Tagging filters
        if(elementKeysArray[0] == "query_string"){
          if(element[ESKeyword] && element[ESKeyword][key] == frontendValue) {
            this.model["query"]["body"]["query"]["bool"]["must"].splice(index,1);
          }
        }

        //Multi value search, Full text
        if(elementKeysArray[0] == "multi_match"){
          if(element[ESKeyword] && element[ESKeyword][key] == frontendValue) {
            this.model["query"]["body"]["query"]["bool"]["must"].splice(index,1);
          }else if(element[ESKeyword] && JSON.stringify(element[ESKeyword][key]) == frontendValue){
            this.model["query"]["body"]["query"]["bool"]["must"].splice(index,1);
          }
        }

        //Single value search
        if((elementKeysArray[0] == "match" || elementKeysArray[0] == "term" || elementKeysArray[0] == "range") && element[ESKeyword] !== undefined){
          let elementECKeywordArray=Object.keys(element[ESKeyword]);
          if(elementECKeywordArray[0] == key) {
            this.model["query"]["body"]["query"]["bool"]["must"].splice(index,1);
          }
        }


      });
      */
    }


  }



  /**
   * @description
   * Get webinars list
   */
   getList() {

    console.log(this.model);

     this.showSectionLoader = true;
     if (Object.keys(this.filterObj).length === 0) this.isFilterApplied = false;

    this.tableListService.getAttendees(this.model).subscribe(
      (response: any) => {
        this.showSectionLoader = false;
        if (response.statusCode == statusCodes.SUCCESS) {
          this.data = response.body.hits;
          //this.limit = response.data.pagination.page_records;

          this.totalItems = (response.body.total.value)-1;//As we're getting records on 0 index based.

          //this.page = response.data.pagination.page;

          //Random Classes for Attendee Image
          this.bgRandom = [];
          for (let i =0; i < this.limit; i++) {
            let randomNumber = Math.floor(Math.random() * this.bg.length);
            this.bgRandom.push(this.bg[randomNumber]);
          }

        } else {
          console.log('Error in api request');
          this.showSectionLoader = false;
        }
      },
      (error) => {
        this.showSectionLoader = false;
        console.log('error', error);

      }
    );

    //this.fetchRegistrantCount();
   // this.fetchAttendeeCount();

  }

  /**
   *
   * @param value
   */
  onEventTypeChange(value:string){
    this.getESWebinars(value);
  }

  getESWebinars(type:string="") {

    let webinarECQuery={
      "query" : {
        "index" : "webinars",
        "body": {
          "from" :0,
          "size": 1000,
          "query" : {
            "bool" :{
              "must" :
              [

              ]
            }
          },
          "sort" : {
            "webinar_created_at" :{
              "order" : "desc"
            }
          }
        }
      }
    };

    if(type!="" && type!='all'){
      let typeEventQuery={
        "match" : {
          "webinar_type" : type
        }
      };

      webinarECQuery["query"]["body"]["query"]["bool"]["must"].push(typeEventQuery);
    }

    let requiredQueryCondition=
    {
      "match" : {
      "owner_id" :this.userId
      }
    };

    let requiredQueryCondition2=  {
      "match" : {
      "webinar_status" : 1
      }
    };

    webinarECQuery["query"]["body"]["query"]["bool"]["must"].push(requiredQueryCondition);
    webinarECQuery["query"]["body"]["query"]["bool"]["must"].push(requiredQueryCondition2);


    this.tableListService.getWebinarsES(webinarECQuery).subscribe(
      (response: any) => {
        this.showSectionLoader = false;
        if (response.statusCode == statusCodes.SUCCESS) {
          this.webinars = response.body.hits;
          this.filterWebinars=this.webinars;
          //this.limit = response.data.pagination.page_records;
          //this.totalItems = response.body.total.value;
          //this.page = response.data.pagination.page;
        } else {
          console.log('Error in api request');
        }
      },
      (error) => {
        console.log('error', error);

      }
    );

  }


  fetchSessionDetail(attendee_email:string="") {
    this.sessionDetaildata=[];
    this.showlistLoader=true;

    const sessionDetailECQuery={
      "query" : {
        "index" : "attendees",
        "body": {
          "from" :0,
          "size": 1000,
          "query" : {
            "bool" :{
              "must" :
              [
                {
                  "match" : {
                  "owner_id" :this.userId
                  }
                },
                {
                  "match" : {
                  "attendee_email.email_raw" : attendee_email
                  }
                }
              ]
            }
          },
          // "sort" : {
          //   "signup" :{
          //     "order" : "desc"
          //   }
          // }
        }
      }
    };

    this.tableListService.getAttendees(sessionDetailECQuery).subscribe(
      (response: any) => {
        this.showlistLoader = false;
        if (response.statusCode == statusCodes.SUCCESS) {
          this.sessionDetaildata = response.body.hits;
          this.sessionDetaildata.forEach((session) => {
            session._source['viewType'] = this.compareDates(session._source.session_date);
          });

        } else {
          console.log('Error in api request');
          this.showlistLoader = false;
        }
      },
      (error) => {
        this.showlistLoader = false;
        console.log('error', error);

      }
    );


  }

  getESoffers() {
    const offersListECQuery={
      "query" : {
        "index" : "offers",
        "body": {
          "from" :0,
          "size": 1000,
          "query" : {
            "bool" :{
              "must" :
              [
                {
                  "match" : {
                  "owner_id" :this.userId
                  }
                },
                {
                  "match" : {
                  "offer_status" : 1
                  }
                }
              ]
            }
          },
        }
      }
    };

    this.tableListService.getOffers(offersListECQuery).subscribe(
      (response: any) => {
        if (response.statusCode == statusCodes.SUCCESS) {
          this.offers = response.body.hits;
          this.filterOffers=this.offers;
        } else {
          console.log('Error in api request');
        }
      },
      (error) => {
        console.log('error', error);

      }
    );
  }

  getESPoll() {
    const pollListECQuery={
      "query" : {
        "index" : "polls",
        "body": {
          "from" :0,
          "size": 1000,
          "query" : {
            "bool" :{
              "must" :
              [
                {
                  "match" : {
                  "owner_id" :this.userId
                  }
                },
                {
                  "match" : {
                  "poll_status" : 1
                  }
                }
              ]
            }
          },
        }
      }
    };

    this.tableListService.getPoll(pollListECQuery).subscribe(
      (response: any) => {
        if (response.statusCode == statusCodes.SUCCESS) {
          this.polls = response.body.hits;
          this.filterPolls=this.polls;
        } else {
          console.log('Error in api request');
        }
      },
      (error) => {
        console.log('error', error);

      }
    );
  }


  getESTimezone() {

    const timezoneListECQuery={
      "query" : {
        "index" : "attendees",
        "body": {
          "from" :0,
          "size": 1,
          "query" : {
            "bool" :{
              "must" : [
                {
                "match":{
                  "owner_id": this.userId
                }
                }
              ]
            }
          },
          "aggs" :{
            "timezones": {
              "terms": {
                "field": "timezone.timezone_raw",
                "size" : 1000
              }
            }
          }

        }
      }
    };

    this.tableListService.getAttendees(timezoneListECQuery).subscribe(
      (response: any) => {
        if (response.statusCode == statusCodes.SUCCESS) {
          this.timezones = response.body.aggregations.timezones.buckets;
          this.filterTimezones=this.timezones;
        } else {
          console.log('Error in api request');
        }
      },
      (error) => {
        console.log('error', error);

      }
    );
  }

  fetchRegistrantCount() {
    this.countRegistrantsQuery= JSON.parse(JSON.stringify(this.model));

    let insertIndex=null;
    //Search In Main query
    insertIndex=this.searchKeyInQuery("term","event_activity");

    //If event_activity already applied condition from filter sidebar, remove it
    if (insertIndex !== null) {

      this.countRegistrantsQuery["query"]["body"]["query"]["bool"]["must"].forEach((element, index) => {

        let elementKeysArray=Object.keys(element);
        //Single value search
        if((elementKeysArray[0] == "match" || elementKeysArray[0] == "term" ) && element["term"] !== undefined){
          let elementECKeywordArray=Object.keys(element["term"]);

          let internalArrayIndex=elementECKeywordArray.indexOf("event_activity");
          this.countRegistrantsQuery["query"]["body"]["query"]["bool"]["must"].splice(internalArrayIndex,1);
        }

      });
    }

    this.tableListService.getAttendees(this.countRegistrantsQuery).subscribe(
      (response: any) => {
        if (response.statusCode == statusCodes.SUCCESS) {
          this.registrants_count = response.body.total.value;
        } else {
          console.log('Error in api request');

        }
      },
      (error) => {

        console.log('error', error);

      }
    );

  }

  fetchAttendeeCount() {

    this.countQuery= JSON.parse(JSON.stringify(this.model));

    const attendeeCountQuery={
      "term": {
        "event_activity":1
        }
    }

    let insertIndex=null;
    //Search In Main query
    insertIndex=this.searchKeyInQuery("term","event_activity");

    //If already applied condition from filter sidebar
    if (insertIndex !== null) {
      // If attended selected as no then show 0.
      if(this.selected_attended == "no"){
        this.attendee_count=0;
        return ;
      }
    }else{
      //Search In Count query

      this.countQuery["query"]["body"]["query"]["bool"]["must"].forEach((element, index) => {

        let elementKeysArray=Object.keys(element);
        //Single value search
        if((elementKeysArray[0] == "match" || elementKeysArray[0] == "term" ) && element["term"] !== undefined){
          let elementECKeywordArray=Object.keys(element["term"]);

          let internalArrayIndex=elementECKeywordArray.indexOf("event_activity");

          if (internalArrayIndex !== -1) {
            insertIndex=index;
          }
        }

      });

      if (insertIndex == null) {
        this.countQuery["query"]["body"]["query"]["bool"]["must"].push(attendeeCountQuery);
      }

    }

    this.tableListService.getAttendees(this.countQuery).subscribe(
      (response: any) => {

        if (response.statusCode == statusCodes.SUCCESS) {
          this.attendee_count = response.body.total.value;
        } else {
          console.log('Error in api request');

        }
      },
      (error) => {

        console.log('error', error);

      }
    );

  }

  pageChanged(page: number) {
    this.page = page;
    this.offset = (this.page -1) * this.limit + 1;

    if(this.offset == 1){
      this.offset=0;
    }

    this.model["query"]["body"]["from"]=this.offset;

    this.getList();
  }

  openSideBar(type: string,id:number=null) {
    if(type== "filter"){
      this.openSidebar=true;
      this.openAttendeeDetailSidebar=false;
    }

    if(type== "attendee_details"){
      this.openAttendeeDetailSidebar=true;
      this.openSidebar=false;
      this.attendee_index=id;
      this.fetchSessionDetail(this.data[this.attendee_index]._source.attendee_email);
    }
  }

  closeSideBar(type: string) {
    if(type== "filter"){
      this.openSidebar=false;
    }

    if(type== "attendee_details"){
      this.openAttendeeDetailSidebar=false;
    }
  }

  selectedFilter(type: string) {
    this.activeFilterTypeOption=type;
  }

  replaceUnderscore(value: string) {
    let valueWithSpace=value.replace(/_/g, ' ');
    let titleCase=valueWithSpace.charAt(0).toUpperCase() + valueWithSpace.slice(1);
    return titleCase;
  }


  clearAllFilters() {
    this.isFilterApplied = false;
    this.filterObj={};
    this.closeSideBar("filter");

    //reset the base query
    //this.model=this.baseECQuery;

    this.model=JSON.parse(JSON.stringify(this.baseECQuery));
    this.countQuery= JSON.parse(JSON.stringify(this.baseECQuery));

    //console.log("reset");
    //console.log(this.model);

    this.getList();
  }




  sortData(sort: Sort) {

    if(!sort.active) return

    if(!sort.direction){
      (event as any).target.click();
    }
    // if (!sort.active || sort.direction === '') {
    //   return;
    // }

    let columnName=sort.active;
    delete this.model["query"]["body"]["sort"];

    //Create SORT KEY first then put value
    this.model["query"]["body"]["sort"]={};

    this.model["query"]["body"]["sort"][columnName]={
      "order" : sort.direction
    };


    this.tableListService.getAttendees(this.model).subscribe(
      (response: any) => {
        this.showSectionLoader = false;
        if (response.statusCode == statusCodes.SUCCESS) {
          this.data = response.body.hits;
          //this.limit = response.data.pagination.page_records;
          this.totalItems = (response.body.total.value)-1;
          //this.page = response.data.pagination.page;

          //Random Classes for Attendee Image
          this.bgRandom = [];
          for (let i =0; i < this.limit; i++) {
            let randomNumber = Math.floor(Math.random() * this.bg.length);
            this.bgRandom.push(this.bg[randomNumber]);
          }
          return "-1";

        } else {
          console.log('Error in api request');
          this.showSectionLoader = false;
        }
      },
      (error) => {
        this.showSectionLoader = false;
        console.log('error', error);

      }
    );

  }

  /**
   * @description
   * Get the value from the array of object based on the id, its value and key whose value needed
   * @param array, id, val and key
   */

  getValueFromStore(store:any, id:string, val:string, key:string){
    let filteredObject = store.filter(item => item[id]==val);
    if(filteredObject){
      return filteredObject[0]._source[key];
    }else{
      return '';
    }
  }

   /*
  Get cdn path from env file
  */
  V2CDN():any  {
    return this.tableListService.getV2CDN();
  }

  /**
   * function to get total records of registrant and attendee
   */
  fetchTotalCount() {
     let countQuery= JSON.parse(JSON.stringify({
      "user_id" : this.userId,
      "query" : {
        "index" : "attendees",
        "body": {
          "from" :0,
          "size": 1,
          "query" : {
            "bool" :{
              "must" : [
                {
                  "term" : {
                    "owner_id" :this.userId
                  }
                }
              ]
            }
          },
          "aggs" :{
            "registrants": {
              "value_count": {
                "field": "owner_id"
              }
            },
            "attendees" :{
                "filter" :{
                    "term":{
                        "event_activity":1
                    }
                },
                "aggs":{
                  "attendees_count":{
                    "value_count": {
                      "field": "event_activity"
                    }
                  }
                }
              }


          }
        }
      }
    }));

    this.tableListService.getAttendees(countQuery).subscribe(
      (response: any) => {
        if (response.statusCode == statusCodes.SUCCESS) {
          this.registrants_count = response.body.aggregations.registrants.value;
          this.attendee_count = response.body.aggregations.attendees.doc_count;
        } else {
          console.log('Error in api request');

        }
      },
      (error) => {

        console.log('error', error);

      }
    );

  }

  onChangeLimit($event) {
    
    this.limit = parseInt($event.value);
    this.offset = 0;//@DESC :: On change limit need to take page to first page with selected limit.
    this.page = 1;
    this.model["query"]["body"]["from"] = this.offset;
    this.model["query"]["body"]["size"] = this.limit;
    this.ngOnInit();
  }

  public sum(limit, val) {
    //TODO:: Need to check if (this.page*limit )>totalItems or not if yes alter code acc to it.
    if (isNumber(limit)) {
      return ((this.page * limit) - limit) + 1;
      return limit + val;
    }else {
      return parseInt(limit)+ val;
    }
  }

  public compareDates(sessionDate: string):boolean { 
    const sessionDateUTC = moment.utc(sessionDate).format();
    const localDateUTC = moment.utc().utcOffset(moment().utcOffset()).add(0, 'hours').format();//need to add three hour;
   //const localDateUTC = moment.utc().format();
    return (moment(localDateUTC).isBefore(sessionDateUTC));
    //`${sessionDate.split(' ')[0]}T${sessionDate.split(' ')[1]}Z`
  }

  public clearFilterRec (obj, ESKeyword, key, frontendValue, refObj){
    
    obj.forEach((element, index) => {

      let elementKeysArray=Object.keys(element);
            
      // nested bool condition
      if(elementKeysArray[0] == "bool"){
        let elementSubKeysArray=Object.keys(element['bool']);
        if(elementSubKeysArray[0]=='should'){
          refObj = this.clearFilterRec(element['bool']['should'], ESKeyword, key, frontendValue, refObj);
        }else if(elementSubKeysArray[0]=='must'){
          refObj = this.clearFilterRec(element['bool']['must'], ESKeyword, key, frontendValue, refObj);
        }
      }

      //Offers and Polls Tagging filters
      if(elementKeysArray[0] == "query_string"){
        if(element[ESKeyword] && element[ESKeyword][key] == frontendValue) {
          refObj = obj.splice(index,1);
        }
      }

      //Multi value search, Full text
      if(elementKeysArray[0] == "multi_match"){
        if(element[ESKeyword] && element[ESKeyword][key] == frontendValue) {
          refObj = obj.splice(index,1);
        }else if(element[ESKeyword] && JSON.stringify(element[ESKeyword][key]) == frontendValue){
          refObj = obj.splice(index,1);
        }
      }

      //Single value search
      if((elementKeysArray[0] == "match" || elementKeysArray[0] == "term" || elementKeysArray[0] == "range") && element[ESKeyword] !== undefined){
        let elementECKeywordArray=Object.keys(element[ESKeyword]);
        if(elementECKeywordArray[0] == key) {
          refObj = obj.splice(index,1);
        }
      }


    });
    return refObj;
   
  }

}
